import { Component, OnInit } from '@angular/core';
import { SearchObjectService, SearchObject } from 'src/app/shared/services/search-object.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear: Number;
  searchObject: SearchObject;
  constructor(private searchObjectService: SearchObjectService,
    private router: Router, ) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        setTimeout(() => {
          this.searchObject = this.searchObjectService.getSearchObject();
        }, 1000);
      }
    });
}

}
